// import { get } from '@/libs/api.request'
import { eloquentsearch } from '@/api/search'
import bodybuilder from 'bodybuilder'
export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    searchManufacturerPart({ commit }, { keyword, matches, terms, exists, aggs, includes, appends, size, specs, sort, page }) {
      let modelType = 'manufacturer_part'
      if (!includes || _.isEmpty(includes)) {
        includes = ['partIdentity']
      }
      let esQueryBuilder = bodybuilder()
      if (keyword && keyword.length > 0) {
        esQueryBuilder.query('query_string', 'query', keyword)
      }
      matches = _.pickBy(matches, (v) => { return !!v })
      if (matches && !_.isEmpty(matches)) {
        _.each(_.keysIn(matches), (k) => {
          if (_.startsWith(k, 'part_number') || _.startsWith(k, 'mpn')) {
            esQueryBuilder.query('wildcard', k, {
              value: '*' + _.get(matches, k) + '*',
              boost: 1.0
            })
          } else {
            esQueryBuilder.query('match', k, {
              query: _.get(matches, k),
              minimum_should_match: "75%",
              // fuzziness: "AUTO",
              operator: "and"
              // zero_terms_query: "all"
            })
          }
          // "wildcard": {
          //   "user": {
          //       "value": "ki*y",
          //       "boost": 1.0,
          //       "rewrite": "constant_score"
          //   }
        // }
        })
      }
      terms = _.pickBy(terms, (v) => { return !!v })
      if (terms && !_.isEmpty(terms)) {
        _.each(_.keysIn(terms), (k) => {
          esQueryBuilder.query('term', k, _.get(terms, k))
        })
      }
      if (exists) {
        let existsFiltered = _.pickBy(exists, (v) => { return _.isNumber(v) || _.isBoolean(v) })
        _.each(existsFiltered, (v, k) => {
          if (v === true || v === 1) {
            esQueryBuilder.filter('exists', k)
          } else {
            esQueryBuilder.notFilter('exists', k)
          }
        })
      }
      specs = _.pickBy(specs, (v) => { return !!v })
      if (specs && !_.isEmpty(specs)) {
        _.each(_.keysIn(specs), (k) => {
          esQueryBuilder.query('nested', { path: 'specs' }, (q) => {
            q.query('term', 'specs.key', k)
            q.query('term', 'specs.display_value', _.get(specs, k))
            return q
          })
        })
      }
      let bodyRaw = esQueryBuilder.build()
      let queryRaw = bodyRaw.query
      return eloquentsearch(modelType, keyword, {
        includes,
        appends,
        aggs,
        query_raw: queryRaw,
        sort,
        page,
        size,
        paginate: {
          page,
          size
        }
      }, 'post').then(res => {
        return res.data
      })
    },
    searchPcbSpecifications({ commit }, { keyword, matches, terms, exists, aggs, includes, appends, size, specs, sort, page }) {
      let modelType = 'pcb_specification'

      let esQueryBuilder = bodybuilder()
      if (keyword && keyword.length > 0) {
        esQueryBuilder.query('query_string', 'query', keyword)
      }

      matches = _.pickBy(matches, (v) => { return !!v })

      terms = _.pickBy(terms, (v) => { return !!v })
      if (terms && !_.isEmpty(terms)) {
        _.each(_.keysIn(terms), (k) => {
          esQueryBuilder.query('term', k, _.get(terms, k))
        })
      }
      if (exists) {
        let existsFiltered = _.pickBy(exists, (v) => { return _.isNumber(v) || _.isBoolean(v) })
        _.each(existsFiltered, (v, k) => {
          if (v === true || v === 1) {
            esQueryBuilder.filter('exists', k)
          } else {
            esQueryBuilder.notFilter('exists', k)
          }
        })
      }

      specs = _.pickBy(specs, (v) => { return !!v })

      let bodyRaw = esQueryBuilder.build()
      let queryRaw = bodyRaw.query
      return eloquentsearch(modelType, keyword, {
        includes,
        appends,
        aggs,
        query_raw: queryRaw,
        sort,
        page,
        size,
        paginate: {
          page,
          size
        }
      }, 'post').then(res => {
        return res.data
      })
    },
    searchPartSpecifications({ commit }, { keyword, matches, terms, exists, aggs, includes, appends, size, specs, sort, page }) {
      let modelType = 'electronic_part_specification'

      let esQueryBuilder = bodybuilder()
      if (keyword && keyword.length > 0) {
        esQueryBuilder.query('query_string', 'query', keyword)
      }

      matches = _.pickBy(matches, (v) => { return !!v })

      terms = _.pickBy(terms, (v) => { return !!v })
      if (terms && !_.isEmpty(terms)) {
        _.each(_.keysIn(terms), (k) => {
          esQueryBuilder.query('term', k, _.get(terms, k))
        })
      }
      if (exists) {
        let existsFiltered = _.pickBy(exists, (v) => { return _.isNumber(v) || _.isBoolean(v) })
        _.each(existsFiltered, (v, k) => {
          if (v === true || v === 1) {
            esQueryBuilder.filter('exists', k)
          } else {
            esQueryBuilder.notFilter('exists', k)
          }
        })
      }

      specs = _.pickBy(specs, (v) => { return !!v })

      let bodyRaw = esQueryBuilder.build()
      let queryRaw = bodyRaw.query
      return eloquentsearch(modelType, keyword, {
        includes,
        appends,
        aggs,
        query_raw: queryRaw,
        sort,
        page,
        size,
        paginate: {
          page,
          size
        }
      }, 'post').then(res => {
        return res.data
      })
    }
  }
}
